import http from '../plugin/AxiosPlugin';

const untils = {

};

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$untils', { value: untils });
  }
};
